@import "../../../styles/_media.css";

.sectionName {
  font-size: var(--font-lg);
  font-weight: var(--font-weight-regular);
  line-height: 135%;
  color: var(--color-bh-blue);
}

.ugcContentWrapper {
  display: flex;
  width: 127%;
  max-width: 1260px;

  @media (max-width: 1300px) {
    width: 100%;
    max-width: 100%;
  }

  @media (--tablet-only) {
    flex-direction: column;
    align-items: center;
  }
}

.ugcCampaignLists {
  display: flex;
  flex-wrap: wrap;
  margin-top: var(--space-md);
  max-width: 930px;

  @media (max-width: 1021px) {
    max-width: 520px;
  }

  @media (max-width: 1081px) {
    max-width: 670px;
  }

  @media (max-width: 1020px) {
    max-width: 500px;
  }

  @media (--tablet-xl) {
    justify-content: center;
    max-width: 400px;
  }

  @media (--tablet-only) {
    justify-content: center;
  }

  .campaignCards {
    max-width: 454px;

    @media (max-width: 1300px) {
      max-width: 400px;
    }

    @media (max-width: 1184px) {
      max-width: 350px;
    }

    @media (max-width: 1081px) {
      max-width: 320px;
    }

    @media (--tablet-xl) {
      max-width: 454px;
    }

    flex: 47%;
    margin-bottom: var(--space-lg);
    padding-bottom: var(--space-sm);
    border-bottom: 1px solid var(--border-color-gray-5);

    @media (--tablet-only) {
      flex: 100%;
      margin-bottom: var(--space-md);
    }

    &.oddItem {
      margin-left: 11px;

      @media (--tablet-only) {
        margin-left: 0;
      }
    }

    &.evenItem {
      margin-right: 11px;

      @media (--tablet-only) {
        margin-right: 0;
      }
    }
  }
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
  margin-top: var(--space-xs);

  @media (--mobile-only) {
    flex-direction: column-reverse;
    gap: var(--space-xxs);
  }

  .date {
    text-align: right;
    font-size: var(--font-xs);
    color: var(--color-gray-10);
    font-weight: var(--font-weight-bold);

    @media (--mobile-only) {
      text-align: left;
      font-size: var(--font-xxs);
    }

    .time {
      font-weight: var(--font-weight-regular);
    }
  }

  .title {
    color: var(--color-bh-black);
    font-family: var(--font-family-ibm-plex);
    font-size: var(--font-md);
    font-weight: var(--font-weight-bold);

    @media (--mobile-only) {
      font-size: 15px;
      font-weight: var(--font-weight-medium);
    }
  }

  .paragraph {
    font-size: var(--font-xs);
    color: var(--color-gray-20);
    font-weight: var(--font-weight-regular);
    line-height: 140%;

    @media (--mobile-only) {
      display: none;
    }
  }
}

.ugcAdsMainContent {
  flex: 100%;
  border-bottom: 1px solid var(--border-color-gray-5);
  margin-bottom: var(--space-lg);
  max-width: 930px;

  > div {
    max-width: 728px;

    :is(iframe) {
      max-width: 728px;
    }

    @media (--tablet-only) {
      max-width: 100%;
    }
  }
}

.ugcAdsSideBar {
  margin-left: var(--space-lg);

  > div {
    margin: var(--space-lg) auto;
    position: sticky;
    top: 130px;
  }
}
